import Backdrop from "../../components/backdrop/Backdrop.jsx";
import "./ManagerProjects.css"
import AddProjectsModal from "../../components/addProjectModal/AddProjectsModal.jsx";
import PayrollModal from "../../components/projectPayrollModal/PayrollModal.jsx";
import React, { useState, useEffect, useRef } from "react";
import { ProjectTeamModal } from "../../components/projectTeamMembersModal/ProjectTeamModal.jsx";
import { createProjectRequest, getAgentProjectsRequest, getAgentsForProjectRequest, getProjectRolesRequest } from "../../services/wisdomServices/projectService.js";
import { requestGetAllUser } from "../../services/wisdomServices/userService.js";
import { Button } from "primereact/button";
import { FilterMatchMode } from "primereact/api";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { getSessionItem } from "../../utils/helper/session.js";
import UpdateProjectModal from "../../components/updateProjectModal/UpdateProjectModal.jsx";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";
import { confirmDialog } from "primereact/confirmdialog";
import { addDocument, deleteDocument, loadDocumentById, loadDocuments } from "../../services/wisdomServices/documentService.js";
import DocumentPreview from "../../components/documentPreview/DocumentPreview.jsx";
import { Can } from "../../security/Can.jsx";
import { PERMISSIONS } from "../../security/permissions.generated.js";

const MAX_DOCUMENT_SIZE = 5 * 1024 * 1024; // 5 MB per file

const isDocumentTooLarge = (file) => file.size > MAX_DOCUMENT_SIZE;

const formatDocumentSize = (size) =>
  `${(size / (1024 * 1024)).toFixed(2)} MB`;

const getDocumentFileKey = (file) =>
  `${file.name}-${file.size}-${file.lastModified}`;

/**
 * @function ManagerProjects
 *
 * @returns {JSX.Element} - projects management dashboard
 */
function ManagerProjects() {
  const user = getSessionItem("User")
  const [showProjectDocuments, setShowProjectDocuments] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [projectDocuments, setProjectDocuments] = useState([]);
  const [documentsLoading, setDocumentsLoading] = useState(false);
  const [documentUploading, setDocumentUploading] = useState(false);
  const [selectedDocumentFiles, setSelectedDocumentFiles] = useState([]);
  const hasOversizedDocumentFiles = selectedDocumentFiles.some(isDocumentTooLarge);
  const [documentPreviewVisible, setDocumentPreviewVisible] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [documentBlobUrl, setDocumentBlobUrl] = useState(null);
  const [documentPreviewLoadingId, setDocumentPreviewLoadingId] = useState(null);
  const [documentDeletingId, setDocumentDeletingId] = useState(null);
  const documentFileUploadRef = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const [openTeamModal, setOpenTeamModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [payrollModal, setPayrollModal] = useState(false);
  const [isAddingProject, setIsAddingProject] = useState(false);
  const [projectRoles, setProjectRoles] = useState([]);
  const [activeUsers, setActiveUsers] = useState([]);
  const [hasFetchedUsers, setHasFetchedUsers] = useState(false);
  const [hasFetchedRoles, setHasFetchedRoles] = useState(false);
  const [projects, setProjects] = useState([]);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  let [loading, setLoading] = useState(true);
  let [showDisabled, setShowDisabled] = useState(false);

  const [filters, setFilters] = useState({
    global: {value:null, matchMode: FilterMatchMode.CONTAINS},
    name: {value:null, matchMode: FilterMatchMode.CONTAINS},
    contactName: {value:null, matchMode: FilterMatchMode.CONTAINS},
    manager: {value:null, matchMode: FilterMatchMode.CONTAINS},
  })

  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const globalFilters = ['name', 'contactName' , 'manager']
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const storedProjects = JSON.parse(sessionStorage.getItem("projects") || "[]");


  /**
   * @function toggleOnlyActive
   * @description - toggles filter for active / disabled projects
   */
  const toggleOnlyActive = (e) => {
    setShowDisabled(e.checked);
    listProjects(page, 25, e.checked);
  };
  /**
   * @async
   * @function getProjectRolesAsync
   * @description - fetches available project roles (once per session)
   */
  const getProjectRolesAsync = async () => {
    if (hasFetchedRoles) return;

    try {
      const response = await getProjectRolesRequest();
      if (!response) {
        console.warn("Project roles not found");
        return;
      }

      const list = response.map((item) => ({
        value: item.id,
        label: item.role,
      }));

      setProjectRoles(list);
      setHasFetchedRoles(true);
    } catch (error) {
      console.error(
        `${new Date().toISOString()} - getProjectRoles error: `,
        error
      );
    }
  };

  /**
   * @async
   * @function getActiveUser
   * @description - fetches active users based on logged-in user permissions
   */
  const getActiveUser = async () => {
    if (hasFetchedUsers) return;

    try {
      const firstResponse = await requestGetAllUser(1, 1000);

      let allUsers = [...firstResponse.data];
      const totalPages = firstResponse.pagination.totalPages;

      if (totalPages > 1) {
        const requests = [];

        for (let i = 2; i <= totalPages; i++) {
          requests.push(requestGetAllUser(i, 1000));
        }

        const responses = await Promise.all(requests);

        responses.forEach((res) => {
          allUsers = [...allUsers, ...res.data];
        });
      }

      const mappedUsers = allUsers.map((element) => ({
        name: element.fullName,
        username: element.username,
        id: element.id,
      }));

      setActiveUsers(mappedUsers);
      setHasFetchedUsers(true);

    } catch (error) {
      console.error("getActiveUser error:", error);
    }
  };

  const configurationBodyTemplate = (rowData) => {
    return(
      <div>
        <Button label="Config" icon="pi pi-cog" severity="info" onClick={() => showDetails(rowData)}/>
      </div>
    )
  }

  const teamMemberBodyTemplate = (rowData) => {
    return(
      <div>
        <Can permission={PERMISSIONS.managersByIdTeamMembers_get}>
          <Button label="Team" icon="pi pi-users" severity="info" onClick={() => showTeamMembers(rowData)}/>
        </Can>
      </div>
    )
  }

  const documentsBodyTemplate = (rowData) => {
    return(
      <div>
        <Button label="Documents" icon="pi pi-book" severity="info" onClick={() => handleOpenProjectDocumentsDialog(rowData)}/>
      </div>
    )
  }

  const reportBodyTemplate = (rowData) => {
    return(
      <div>
        <Button label="Invoice" icon="pi pi-receipt" severity="info" onClick={() => showPayrollSummary(rowData)}/>
      </div>
    )
  }

  const columns = [
    {
      field: "name",
      header: "Project"
    },
    {
      field: "contactName",
      header: "Contact Name"
    },
    {
      field: "manager",
      header: "Manager"
    },
    {
      field: "mobileTracker",
      header: "Mobile Tracker"
    },
    {
      field: "disabled",
      header: "Disabled"
    },
    {
      header: "Configuration",
      body: configurationBodyTemplate,
      headerStyle:{ textAlign: "center" },
      bodyStyle: { textAlign: "center" }
    },
    {
      header: "Team",
      body: teamMemberBodyTemplate,
      headerStyle:{ textAlign: "center" },
      bodyStyle: { textAlign: "center" }
    },
    {
      header: "Documents",
      body: documentsBodyTemplate,
      headerStyle:{ textAlign: "center" },
      bodyStyle: { textAlign: "center" }
    },
    {
      header: "Report",
      body:reportBodyTemplate,
      headerStyle:{ textAlign: "center" },
      bodyStyle: { textAlign: "center" }
    },
  ];
  /**
   * @async
   * @function showPayrollSummary
   * @param {Object} modalData 
   * @description - opens payroll summary modal
   */
  let showPayrollSummary = async (modalData) => {
    setModalData({...modalData});
    setPayrollModal(true);
  };

  /**
   * @async
   * @function showDetails
   * @param {Object} modalData
   * @description - opens project configuration modal 
   */
  let showDetails = async (modalData) => {
    setModalData({ ...modalData });
    setOpenModal(true);
  };

  /**
   * @async
   * @function showTeamMembers
   * @param {Object} modalData
   * @description - opens team members modal for a project 
   */
  let showTeamMembers = async (modalData) => {
    try {
        if (activeUsers.length === 0) await getActiveUser();
        if (projectRoles.length === 0) await getProjectRolesAsync();
    
        let agents = [];
        let response = await getAgentsForProjectRequest(modalData["id"])
        for (const item of response) {
          agents.push({
            id: item.id,
            agentname: item.firstName + " " + item.lastName,
            username: item.username,
            roleId: item.roleId,
            role: item.role,
          });
        }
        modalData.agents = agents;
      
    } catch (error) {
      console.error(error)
      
    } finally {
      setModalData({ ...modalData });
      setOpenTeamModal(true);
    }
  };


  const handleOpenProjectDocumentsDialog = async (rowData) => {
    setSelectedProject(rowData);
    setShowProjectDocuments(true);
    setDocumentsLoading(true);

    try {
      const documents = await loadDocuments(rowData.id);
      setProjectDocuments(documents.data);
    } catch (error) {
      console.error("Error loading project documents:", error);
    } finally {
      setDocumentsLoading(false);
    }
  };

  const handleCloseProjectDocumentsDialog = () => {
    setSelectedDocumentFiles([]);
    documentFileUploadRef.current?.clear();

    projectDocuments.forEach((document) => {
      if (document.isLocal && document.url) {
        URL.revokeObjectURL(document.url);
      }
    });

    setShowProjectDocuments(false);
    setSelectedProject(null);
    setProjectDocuments([]);
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const result = reader.result;

        if (typeof result !== "string") {
          reject(new Error("Could not convert file to Base64"));
          return;
        }

        const base64 = result.split(",")[1];

        resolve(base64);
      };

      reader.onerror = () => {
        reject(new Error(`Could not read file: ${file.name}`));
      };

      reader.readAsDataURL(file);
    });
  };


  const handleUploadProjectDocument = async () => {
    if (
      documentUploading ||
      !selectedDocumentFiles.length ||
      !selectedProject?.id ||
      selectedDocumentFiles.some(isDocumentTooLarge)
    ) {
      return;
    }

    setDocumentUploading(true);

    try {
      const uploadedDocuments = [];

      for (const file of selectedDocumentFiles) {
        // Validate again before converting the file or sending it to the API.
        if (isDocumentTooLarge(file)) {
          return;
        }

        const fileBase64 = await fileToBase64(file);

        const payload = {
          name: file.name,
          fileBase64,
          contentType: file.type || "application/octet-stream",
        };

        const uploadedDocument = await addDocument(
          selectedProject.id,
          payload
        );

        uploadedDocuments.push(uploadedDocument);
      }

      setProjectDocuments((current) => [
        ...current,
        ...uploadedDocuments,
      ]);

      setSelectedDocumentFiles([]);
      documentFileUploadRef.current?.clear();
    } catch (error) {
      console.error("Error uploading project document:", error);
    } finally {
      setDocumentUploading(false);
    }
  };

  const handleSelectProjectDocuments = (event) => {
    const files = Array.from(event.files || []);

    // The custom list owns the selection. Reset PrimeReact's internal input
    // so the button never stays stuck on a previously selected file.
    documentFileUploadRef.current?.clear();

    setSelectedDocumentFiles((current) => {
      const existingKeys = new Set(current.map(getDocumentFileKey));
      const newFiles = files.filter((file) => {
        const key = getDocumentFileKey(file);
        if (existingKeys.has(key)) return false;
        existingKeys.add(key);
        return true;
      });

      return [...current, ...newFiles];
    });
  };

  const handleClearSelectedProjectDocuments = () => {
    if (documentUploading) return;
    setSelectedDocumentFiles([]);
    documentFileUploadRef.current?.clear();
  };

  const handleRemoveSelectedProjectDocument = (fileToRemove) => {
    if (documentUploading) return;

    setSelectedDocumentFiles((current) =>
      current.filter((file) => file !== fileToRemove)
    );
  };


  const handleDeleteProjectDocument = async (document) => {
    if (!selectedProject?.id || !document?.id) return;

    setDocumentDeletingId(document.id);

    try {
      await deleteDocument(selectedProject.id, document.id);

      setProjectDocuments((current) =>
        current.filter((item) => item.id !== document.id)
      );
    } catch (error) {
      console.error("Error deleting project document:", error);
    } finally {
      setDocumentDeletingId(null);
    }
  };

  const confirmDeleteProjectDocument = (document) => {
    confirmDialog({
      message: `Are you sure you want to delete "${document.name}"? This action cannot be undone.`,
      header: "Delete Document",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Delete",
      rejectLabel: "Cancel",
      acceptClassName: "p-button-danger",
      accept: () => handleDeleteProjectDocument(document),
    });
  };

  const handleOpenDocumentPreview = async (document) => {
  setSelectedDocument(document);
  setDocumentPreviewLoadingId(document.id);

  try {
    if (documentBlobUrl) {
      URL.revokeObjectURL(documentBlobUrl);
      setDocumentBlobUrl(null);
    }

    if (document.url) {
      setDocumentBlobUrl(document.url);
    } else {
      const fileBlob = await loadDocumentById(
        document.projectId,
        document.id
      );

      setDocumentBlobUrl(URL.createObjectURL(fileBlob));
    }

    setDocumentPreviewVisible(true);

  } catch (error) {
    console.error("Error opening project document:", error);
  } finally {
    setDocumentPreviewLoadingId(null);
  }
};

  const handleCloseDocumentPreview = () => {
    setDocumentPreviewVisible(false);
    setSelectedDocument(null);

    // URLs locais pertencem à lista e só são revogadas ao fechar o dialog principal.
    if (documentBlobUrl && !selectedDocument?.isLocal) {
      URL.revokeObjectURL(documentBlobUrl);
    }

    setDocumentBlobUrl(null);
  };

  const documentNameBodyTemplate = (document) => (
    <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
      <i className="pi pi-file" style={{ color: "#0BADDE", fontSize: "1.25rem" }} />
      <span>{document.name}</span>
    </div>
  );

  const documentDateBodyTemplate = (document) =>
    document.createdAt ? new Date(document.createdAt).toLocaleString() : "-";

  const documentActionsBodyTemplate = (document) => (
    <div style={{ display: "flex", justifyContent: "center", gap: "0.25rem" }}>
      <Button
        label="View"
        icon="pi pi-eye"
        text
        severity="info"
        loading={documentPreviewLoadingId === document.id}
        disabled={
          documentPreviewLoadingId === document.id ||
          documentDeletingId === document.id
        }
        onClick={() => handleOpenDocumentPreview(document)}
      />

      <Button
        label="Delete"
        icon="pi pi-trash"
        text
        severity="danger"
        loading={documentDeletingId === document.id}
        disabled={
          documentDeletingId === document.id ||
          documentPreviewLoadingId === document.id
        }
        onClick={() => confirmDeleteProjectDocument(document)}
      />
    </div>
  );

  function closeDetails() {
    setOpenModal(false);
    listProjects(showDisabled);
    setModalData([]);
  }

  function closeDetailsModal() {
    setOpenModal(false);
    setModalData([]);
  }

  function closeTeamMembers(row) {
    setOpenTeamModal(false);
    listProjects(showDisabled);
    setModalData([]);
  }

  function closeTeamMembersModal() {
    setOpenTeamModal(false);
    setModalData([]);
  }

  function closeAddProjectModal() {
    setOpenAddModal(false);
  }

  function openAddProjectsModal() {
    setOpenAddModal(true);
  }

  function closeAddModal() {
    setOpenAddModal(false);
  }

  
  const listProjects = async (page, rows, showDisabled) => {
    try {
      setLoading(true)
      const response = await getAgentProjectsRequest(user.id, showDisabled, true, 1, 100);
      setProjects(response.data || []);
      setTotalRecords(response.pagination?.totalResults || 0);

      setPage(page);
      setRows(rows);
      setFirst((page - 1) * rows);
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  };

  const onPageChange = (event) => {
    const newPage = event.page + 1;
    const newRows = event.rows;

    listProjects(newPage, newRows, showDisabled);
  };

  function closePayrollModal() {
    setPayrollModal(false);
  }

  /**
   * @async
   * @function addProject
   * @param {Object} projectObject 
   * @description - creates a new project
   */
  const addProject = async (projectObject) => {
    setIsAddingProject(true);
    try {
      const createdProject = await createProjectRequest(projectObject);
      if(typeof(createdProject) == "object"){
        setProjects((prev) => [...prev, createdProject]);
        closeAddModal();
        await listProjects(page, 25, showDisabled);
      }

      try {
        const storedProjects = JSON.parse(sessionStorage.getItem("projects")) || [];

        const alreadyExists = storedProjects.some(p => p.id === createdProject.id);
        if (!alreadyExists) {
          storedProjects.push(createdProject);
          sessionStorage.setItem("projects", JSON.stringify(storedProjects));
        }
      } catch (err) {
        console.error("Error updating sessionStorage after project creation:", err);
      }

    } catch (error) {
      console.error(error);
    } finally {
      setIsAddingProject(false);
    }
  };

  /**
   * @async
   * @function fetchData
   * @description - initial data load
   */
  const fetchData = async () => {
    setLoading(true);
    try {
      await Promise.all([
        listProjects(page, 25, showDisabled),
        getProjectRolesAsync(),
        getActiveUser(),
      ]);
    } catch (error) {
      console.error("Error loading initial data:", error);
    } finally {
      setLoading(false);
    }
  };

  const tableHeader = () => {
    return (
      <div className="projects-table-header">
        <Button className="projects-table-add-project-button" label='New project' icon="pi pi-plus-circle" severity="success" onClick={() => openAddProjectsModal()}/>
        <div>
          <IconField iconPosition="left">
              <InputIcon className="pi pi-search" />
              <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
          </IconField>
          <div className="projects-onlyActive">
            <Checkbox 
              inputId="project-table-only-active-radio-button" 
              onChange={toggleOnlyActive} 
              checked={showDisabled}>
            </Checkbox>
            <label htmlFor="project-table-only-active-radio-button" style={{fontSize:"12px"}}>Show disabled</label>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!storedProjects || storedProjects.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#999", fontWeight: 400 }}>
          You don’t have any assigned projects yet to access <strong>Projects</strong> page.
        </h1>
      </div>
    );
  }

  return (
    <div className="dashboardProjectsMain">
      <div>
        <h1 className="dashboardProjectsMain-header">Projects</h1>
      </div>
        <DataTable 
          columns={columns}
          value={projects}
          filters={filters}
          globalFilterFields={globalFilters}
          header={tableHeader}
          paginator
          loading={loading}
          rows={10}
        >
          {columns.map((column, i) => {
              return(
                  <Column 
                      key={column.field}
                      field={column.field} 
                      header={column.header} 
                      body={column?.body}
                      bodyStyle={column?.bodyStyle}
                      headerStyle={column?.headerStyle}
                  />
              )
          })}
        </DataTable>

        {openModal && (
          <UpdateProjectModal
            modalData={modalData}
            onClose={closeDetailsModal}
            saveChanges={closeDetails}
            open={openModal}
          />

          )}
          {openTeamModal && (
            <ProjectTeamModal
              teamMembers={modalData}
              onClose={closeTeamMembersModal}
              onCancel={closeTeamMembers}
              updateTeamMembers={showTeamMembers}
              users={activeUsers}
              projectRoles={projectRoles}
              open={openTeamModal}
            />
          )}
          {payrollModal && (
            <PayrollModal modalData={modalData} onCancel={closePayrollModal} open={payrollModal}/>
          )}

          {payrollModal && <Backdrop onCancel={closePayrollModal} />}

          {openModal && <Backdrop onCancel={closeDetailsModal} />}
          {openAddModal && (
            <AddProjectsModal
              onCancel={closeAddModal}
              addProject={addProject}
              onClose={closeAddProjectModal}
              isAddingProject={isAddingProject}
            />
          )}
            {/* PROJECT DOCUMENTS DIALOG */}
            <Dialog
              visible={showProjectDocuments}
              dismissableMask
              closeOnEscape
              onHide={handleCloseProjectDocumentsDialog}
              header={`Documents - ${selectedProject?.name || "Project"}`}
              style={{ width: "75vw" }}
              breakpoints={{ "960px": "90vw", "641px": "100vw" }}
              maximizable
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.75rem",
                  marginBottom: "1rem",
                  padding: "1rem",
                  border: "1px solid var(--surface-border)",
                  borderRadius: "8px",
                  background: "var(--surface-50)",
                }}
              >
                <div style={{ fontWeight: 600 }}>Add project document</div>
                <div style={{ fontSize: "0.875rem", color: "var(--text-color-secondary)" }}>
                  1. Select one file. 2. Review the selection. 3. Upload the documents to this project. Maximum file size: 5 MB per file.
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "0.75rem",
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                >
                  <FileUpload
                    ref={documentFileUploadRef}
                    mode="basic"
                    name="projectDocument"
                    accept=".pdf,.png,.jpg,.jpeg,.txt,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                    multiple
                    chooseLabel="Select files"
                    chooseOptions={{
                      icon: "pi pi-folder-open",
                      className: "p-button-info",
                    }}
                    onSelect={handleSelectProjectDocuments}
                    auto={false}
                    customUpload
                    disabled={documentUploading}
                  />

                  <Button
                    label={`Upload${selectedDocumentFiles.length ? ` (${selectedDocumentFiles.length})` : ""}`}
                    icon="pi pi-upload"
                    severity="success"
                    onClick={handleUploadProjectDocument}
                    loading={documentUploading}
                    disabled={
                      documentUploading ||
                      selectedDocumentFiles.length === 0 ||
                      hasOversizedDocumentFiles
                    }
                  />

                  <Button
                    label="Clear"
                    icon="pi pi-times"
                    severity="secondary"
                    outlined
                    onClick={handleClearSelectedProjectDocuments}
                    disabled={documentUploading || selectedDocumentFiles.length === 0}
                  />
                </div>

                {selectedDocumentFiles.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "0.5rem",
                      paddingTop: "0.25rem",
                    }}
                  >
                    <div style={{ fontSize: "0.85rem", fontWeight: 600 }}>
                      Selected files
                    </div>

                    {selectedDocumentFiles.map((file) => {
                      const isOversized = isDocumentTooLarge(file);

                      return (
                        <div
                          key={getDocumentFileKey(file)}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.35rem",
                            padding: "0.6rem 0.75rem",
                            border: `1px solid ${
                              isOversized
                                ? "var(--red-300)"
                                : "var(--surface-border)"
                            }`,
                            borderRadius: "6px",
                            background: isOversized
                              ? "var(--red-50)"
                              : "var(--surface-0)",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                              flexWrap: "wrap",
                              minWidth: 0,
                            }}
                          >
                            <i
                              className={`pi ${
                                isOversized
                                  ? "pi-exclamation-circle"
                                  : "pi-file"
                              }`}
                              style={{
                                color: isOversized
                                  ? "var(--red-500)"
                                  : "var(--text-color-secondary)",
                              }}
                            />

                            <span
                              style={{
                                fontSize: "0.85rem",
                                wordBreak: "break-word",
                                minWidth: 0,
                              }}
                            >
                              {file.name}
                            </span>

                            <span
                              style={{
                                fontSize: "0.75rem",
                                color: "var(--text-color-secondary)",
                              }}
                            >
                              ({formatDocumentSize(file.size)})
                            </span>

                            <Button
                              icon="pi pi-times"
                              rounded
                              text
                              severity="secondary"
                              size="small"
                              aria-label={`Remove ${file.name}`}
                              tooltip="Remove from selection"
                              tooltipOptions={{ position: "top" }}
                              onClick={() =>
                                handleRemoveSelectedProjectDocument(file)
                              }
                              disabled={documentUploading}
                              style={{ marginLeft: "auto" }}
                            />
                          </div>

                          {isOversized && (
                            <span
                              role="alert"
                              style={{
                                color: "var(--red-500)",
                                fontSize: "0.8rem",
                                paddingLeft: "1.5rem",
                              }}
                            >
                              File size exceeds the 5 MB limit. Please select a smaller file.
                            </span>
                          )}
                        </div>
                      );
                    })}

                    {hasOversizedDocumentFiles && (
                      <span
                        role="alert"
                        style={{
                          color: "var(--red-500)",
                          fontSize: "0.85rem",
                          fontWeight: 500,
                        }}
                      >
                        Remove or clear the files that exceed 5 MB before uploading.
                      </span>
                    )}
                  </div>
                )}
              </div>

              <DataTable
                value={projectDocuments}
                loading={documentsLoading || documentUploading}
                emptyMessage="No documents found for this project."
                paginator={projectDocuments.length > 10}
                rows={10}
                stripedRows
                scrollable
              >
                <Column
                  header="Document"
                  body={documentNameBodyTemplate}
                  style={{ minWidth: "18rem" }}
                />
                <Column
                  header="Uploaded at"
                  body={documentDateBodyTemplate}
                  style={{ minWidth: "11rem" }}
                />
                <Column
                  header="Actions"
                  body={documentActionsBodyTemplate}
                  style={{ width: "14rem", textAlign: "center" }}
                  headerStyle={{ textAlign: "center" }}
                />
              </DataTable>

            </Dialog>

            {/* PROJECT DOCUMENT PREVIEW DIALOG */}
            <Dialog
              visible={documentPreviewVisible}
              onHide={handleCloseDocumentPreview}
              header={`Document - ${selectedDocument?.name || ""}`}
              style={{ width: "80vw" }}
              breakpoints={{ "960px": "95vw", "641px": "100vw" }}
              maximizable
            >
              <div style={{ width: "100%", height: "75vh" }}>
                {!documentBlobUrl ? (
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Loading document...
                  </div>
                ) : selectedDocument?.name?.toLowerCase().endsWith(".pdf") ? (
                  <iframe
                    src={documentBlobUrl}
                    title={`Document preview - ${selectedDocument?.name}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                    }}
                  />
                ) : /\.(png|jpg|jpeg|gif|webp)$/i.test(selectedDocument?.name || "") ? (
                  <img
                    src={documentBlobUrl}
                    alt={selectedDocument?.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                ) : selectedDocument?.name?.toLowerCase().endsWith(".docx") ? (
                  <DocumentPreview
                    url={documentBlobUrl}
                    document={selectedDocument}
                  />
                ) : (
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "1rem",
                      textAlign: "center",
                    }}
                  >
                    <i
                      className="pi pi-file"
                      style={{ fontSize: "3rem", color: "var(--text-color-secondary)" }}
                    />

                    <div>
                      <strong>Preview is not available for this file type.</strong>
                      <p style={{ color: "var(--text-color-secondary)" }}>
                        You can download the document and open it in a compatible application.
                      </p>
                    </div>

                    <Button
                      label="Download document"
                      icon="pi pi-download"
                      severity="info"
                      onClick={() => {
                        const link = document.createElement("a");
                        link.href = documentBlobUrl;
                        link.download = selectedDocument?.name || "document";
                        link.click();
                      }}
                    />
                  </div>
                )}
              </div>
            </Dialog>
    </div>
  );
}

export default ManagerProjects;